var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pt-2 pl-3 ma-2",attrs:{"height":"90px"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('img',{attrs:{"src":_vm.logoUrl}}),_c('div',{attrs:{"height":"64px"}},[_c('div',{staticClass:"office-name ml-4 mt-4",domProps:{"textContent":_vm._s(_vm.officeName)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }